var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContributorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 7.4L10.425 3.775C10.625 3.50833 10.8625 3.3125 11.1375 3.1875C11.4125 3.0625 11.7 3 12 3C12.3 3 12.5875 3.0625 12.8625 3.1875C13.1375 3.3125 13.375 3.50833 13.575 3.775L16.375 7.4L20.625 8.825C21.0583 8.95833 21.4 9.20417 21.65 9.5625C21.9 9.92083 22.025 10.3167 22.025 10.75C22.025 10.95 21.9958 11.15 21.9375 11.35C21.8792 11.55 21.7833 11.7417 21.65 11.925L18.9 15.825L19 19.925C19.0167 20.5083 18.825 21 18.425 21.4C18.025 21.8 17.5583 22 17.025 22C16.9917 22 16.8083 21.975 16.475 21.925L12 20.675L7.525 21.925C7.44167 21.9583 7.35 21.9792 7.25 21.9875C7.15 21.9958 7.05833 22 6.975 22C6.44167 22 5.975 21.8 5.575 21.4C5.175 21 4.98333 20.5083 5 19.925L5.1 15.8L2.375 11.925C2.24167 11.7417 2.14583 11.55 2.0875 11.35C2.02917 11.15 2 10.95 2 10.75C2 10.3333 2.12083 9.94583 2.3625 9.5875C2.60417 9.22917 2.94167 8.975 3.375 8.825L7.625 7.4ZM8.85 9.125L4 10.725L7.1 15.2L7 19.975L12 18.6L17 20L16.9 15.2L20 10.775L15.15 9.125L12 5L8.85 9.125Z",
    fill: "url(#paint0_linear_11757_124031)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11757_124031",
    x1: 2,
    y1: 12.5,
    x2: 22.025,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#0054C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#1E71DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    stopColor: "#4697FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContributorIcon);
export default __webpack_public_path__ + "static/media/contributor-icon.3f57f61c358547993ffbee7e0c950b4b.svg";
export { ForwardRef as ReactComponent };